<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Toggle } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import { real_id } from 'src/helpers/interface_helpers';

	export let device;

	let loading: boolean = false;
	let reverse: boolean = readDeviceSettings(device.id)?.['pm1:0']?.reverse;
	let cacheReverse: boolean = reverse;

	const params: { id: number; config: { reverse: boolean } } = {
		id: 0,
		config: {
			reverse: reverse,
		},
	};

	const toggleMeasurement: () => Promise<void> = async () => {
		if (loading) return;
		reverse = !reverse;
		if ($showNewLayout) {
			await saveSettings();
		}
	};
	const saveSettings: () => Promise<void> = async () => {
		if (reverse === cacheReverse) return;
		loading = true;
		params.id = 0;
		params.config.reverse = reverse;
		const res: SettingRequest = await gen2Request(device, 'Switch.SetConfig', {
			...params,
		});
		const response: SettingRequest = await onSettingsResponse(res, device);
		if (response?.isok) {
			cacheReverse = reverse;
		} else {
			reverse = cacheReverse;
		}
		loading = false;
	};
	/**
	 * id: 9
	 * method: "pm1.setconfig"
	 * params: {id: 0, config: {reverse: true}}
	 * src:  "650058d3-90b7-47ea-b5f4-4738d47f1425"
	 */
</script>

<Toggle
	class="mb-s"
	checked={reverse}
	on:click={toggleMeasurement}
	size="m"
	disabled={loading}
	id="toggle-1coxatn"
	>{$format(`label_enable`, {
		default: `Enable`,
	})}</Toggle
>
{#if !$showNewLayout}
	<Button {loading} width="full" size="m" on:click={saveSettings}>
		{$format('button_save', { default: 'Save' })}
	</Button>
{/if}
